import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import UpdateContactAndAccountDetailsBlockData from '../../../Models/Content/UpdateContactAndAccountDetailsBlockData';
import UpdateContactAndAccountDetailsMain from './UpdateContactAndAccountDetailsMain';
export default class UpdateContactAndAccountDetailsBlock extends EpiComponent<UpdateContactAndAccountDetailsBlockData> {
  constructor(props) {
    super(props);

  }

  public render(): ReactNode | ReactNodeArray | null {

    //develop popup benefit
    //return  <PopupBenefitMain context={this.getContext()} iContent={this.props.data} />
    //develop update contact and account details
   return  <UpdateContactAndAccountDetailsMain context={this.getContext()} iContent={this.props.data} />
  }
}
